import React from 'react';
import ActionButton from '../action-button';

const defaultCaptions = {
  back: 'Back',
  skip: 'Skip',
};

// @ts-ignore TS(2322): Type 'null' is not assignable to type '(...args: a... Remove this comment to see the full error message
const OnboardingHeader = ({
  captions = defaultCaptions,
  logo,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type '(...args: any[]) => any'.
  onBack = null,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type '(...args: any[]) => any'.
  onSkip = null,
}) => (
  <div className="ws-ui-onboarding-header">
    {onBack && (
      // @ts-ignore TS(2322): Type 'string' is not assignable to type 'null | un... Remove this comment to see the full error message
      <ActionButton format="text" iconGlyph="back" onClick={onBack} label={captions.back} />
    )}
    <div
      className="ws-ui-onboarding-header__logo"
      style={{ width: logo.width, height: logo.height }}
    >
      {logo.src && <img src={logo.src} width={logo.width} height={logo.height} alt={logo.alt} />}
    </div>
    {/* @ts-ignore TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message */}
    {onSkip && <ActionButton format="text" onClick={onSkip} label={captions.skip} />}
  </div>
);

export default OnboardingHeader;
